module.exports = __webpack_public_path__ + "img/logo@3x.64ac4871.png";